import React, { Component,createRef } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes,bytesToSize} from '../../FormBuilderFunctions/FieldProps';
import {callPOST} from '../../../../Utils/ApiUtil';
import {fileNameShortenForDisplay,parameterizedURLAccessToken,isSet} from '../../../../Utils/CommonFunctions';
import {
  loader,
} from '../../../../store/actions/auth';
import {
  failMessage,
  succMessage
} from '../../../../store/actions/CommonActions';
import Wrp from '../../../../hoc/Wrp/Wrp';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import HeaderLabel from "./HeaderLabel";
import AvatarImageUpload from '../../../UI/AvatarImageUpload';

class ImageUpload extends Component {

  fileObj = [];
  fileArray = [];
  constructor(props) {
    super(props)
    this.state = {
      files: [],
      totalSize:0,
      maxSize:20
    }
    this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);
    this.myUploadRef = createRef();
    this.uploadFiles = this.uploadFiles.bind(this)
  }
  
  componentDidMount =()=>{
    this.updateFilesSizes();
  }  
  render() {
    const  {
      item,
      className,
      validationForms,
      section,
      fieldObj
    } = this.props;

    
    const attr = formFieldsAttributes(
      {...item,className:className
    },validationForms,e => this.props.onChangeInputAction(fieldObj,e));
    const filesLength = isSet(item.files,[]).length
    // console.log('item.filesitem.files',item);
    const readOnlyVal = attr.fieldAttributes ? attr.fieldAttributes.readOnly : false;
    return (
      <Wrp>
        {(item.is_avatar===true)?
          <FormBlocks {...this.props} isLabel={false} attr={attr}>
            <HeaderLabel
              item={item}
              {...item}
              sectionType={section.type}
              label={item.label}  />
            <AvatarImageUpload 
              uploadFileRef={this.myUploadRef}
              isReadOnly={(this.props.item.modType==='LAYOUT')?true:false}
              fileClickHandler={this.uploadMultipleFiles}
              removeHandler={this.removeAvatarImage}
              fileChangeHandler={this.onFileChange}
              imageId={(filesLength>0)?isSet(item.files,[{id:''}])[0].id:''}
              fieldAttributes={attr.fieldAttributes} />
           </FormBlocks>
        :
        <FormBlocks {...this.props}  attr={attr}>
          <div className="border" style={{borderRadius:'0.25rem',padding:'5px',width:'100%'}}>
				    <div className="position-relative">
              <input 
                type="file" 
                accept="image/*" 
                id="imageUploadButton" 
                ref={'uploadMultipleFiles'} 
                multiple 
                disabled={readOnlyVal}
                style={{display:'none'}} 
                onChange={this.uploadMultipleFiles}/>
                {/* type="image/*" */}
              <div className="border-bottom card-title mb-2 cursor-pointer" onClick={this.onFileChange}>
                <div className="totalFileSize text-left">
                  Total size is limited to <b> 20 MB</b> or a maximum of <b className="proximas">{this.props.item.max}</b>&nbsp;
                images.
                </div>
              {readOnlyVal === false ?
                <div className="text-right">  
                  <i className="fas fa-upload secondary_color"></i> <small>Upload New</small>
                </div>
              : null}
					    
					</div>
				</div>
        {(filesLength>0)?
          <div className="text-right">
            <span style={{fontSize:'0.8rem',color:'#999999'}}>{bytesToSize(this.state.totalSize)} /20 MB</span>
          </div>
          :''}
        {(filesLength>0)?
          <div className="row">
            <div className="col-12">
              {isSet(item.files,[]).map((itemFile,index)=>{
                let imagePath = '/assets/img/noimage.png';
                if(itemFile.file && itemFile.file.type){
                  imagePath = URL.createObjectURL(itemFile.file);
                }else if(itemFile.id!==''){
                  imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
                }       
                const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
                return(
                  <div key={index}>
                    <div className="d-flex">
                      <div className="avatar avatar-sm">
                        <img src={imagePath} style={{float:'left',width:'50px',height:'45px',backgroundSize:'cover'}} alt="" className="imagecheck-image" />
                      </div>
                      <div className="flex-1 ml-3 pt-1">
                        <h6 className="fw-bold mb-1">{itemFileLabel}</h6>
                      </div>
                      <div className="float-right pt-1">
                        <small className="text-muted" onClick={this.callDownloadImgFile.bind(this,itemFile)}><i className="fas fa-download fa-lg cursor-pointer"></i></small>&nbsp;&nbsp;
                        <small className="text-muted" onClick={this.removeAddedFile.bind(this,index)}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>
                      </div>
                    </div>
                    <div className="separator-dashed m-1"></div>
                  </div>
                )
            })}
				    </div>
          </div>
        :
        <div className="text-center">
				      <i className="fas fa-file-image fa-2x last_light_color"></i>
              <p className="last_light_color mb-0 text-small"> No Files added</p>
        </div>
      }
             </div>
       </FormBlocks>
        }
      </Wrp>
      
    );
  }
    callDownloadImgFile = (itemFile) => {
      document.location.href = parameterizedURLAccessToken('files/download?fileId='+itemFile.id);
    }
    updateFilesSizes = ()=>{
      let updateFiles = isSet(this.props.item.files,[]);
      let totalSize = 0;
      updateFiles.map((itemFile)=>{
        const fileSize = itemFile.size;
        totalSize = Number(fileSize)+Number(totalSize);
      })
      this.setState({totalSize:totalSize});
    }
    
    uploadFileAPICall = async (files)=>{
      let totalFileLength =isSet(this.props.item.files,[]).length+files.length;
      let totalFilesize = 0;
      
      if(this.props.item.is_avatar===true){

      }else if(totalFileLength>Number(this.props.item.max)){
        this.props.failMessage('You can upload a maximum of '+this.props.item.max+' images only.');
        return false;
      }

      if(Object.entries(files).length===0){
        return false;
      }

      Object.entries(files).map(([key, fileItem]) => {
        const totalFilesize1 = ((fileItem.size / (1024*1024)).toFixed(2));
        totalFilesize += parseFloat(totalFilesize1);
      })

      if(this.props.item.files) {
        isSet(this.props.item.files,[]).map(fileItem => {
          const totalFilesize1 = ((fileItem.size / (1024*1024)).toFixed(2));
          totalFilesize += parseFloat(totalFilesize1);
        })
      }

      if(totalFilesize > this.state.maxSize) {
        this.props.failMessage('Image maximum size exceeded.');
        return false;  
      }

      this.props.Loader(true);
      if(this.props.item.is_avatar===true){
        await this.props.onChangeInputAction(this.props.fieldObj,[],'Files');
      }
      Object.entries(files).map(([key, fileItem]) => {
        const formData = new FormData();            
        formData.append("upload_file", fileItem);
        const APIURL = 'files/upload';
        callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
        .then(res => {    
          this.props.Loader(false);
            if(res.status==200){                        
                const response = res.data;
              if(response.code===200){
                  const responseData =  response.data;
                  let filesArr = isSet(this.props.item.files,[]);
                  filesArr.push({
                    id:responseData,
                    value:responseData,
                    checked:null,
                    file:fileItem,
                    label:fileItem.name,
                    size:fileItem.size
                  });
                  this.props.onChangeInputAction(this.props.fieldObj,filesArr,'Files');
                  this.updateFilesSizes();
                }else{
                  this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
                }                                                
            }else{
                // this.props.Loader();
                this.props.failMessage('Something went wrong..');
            }
        })
        .catch(err => {
            console.log(err);
            this.props.Loader(false);
            this.props.failMessage('Something went wrong..');                    
        })
    })
  }
  removeAvatarImage = ()=>{
    this.props.onChangeInputAction(this.props.fieldObj,[],'Files');
  }
    uploadMultipleFiles(e) {
        let updateFiles = this.state.files;
        this.uploadFileAPICall(e.target.files);
        updateFiles.push(e.target.files)
        this.setState({files:updateFiles}); 
    }

    uploadFiles(e) {
        e.preventDefault()
        // console.log(this.state.file);
    }
    onFileChange =()=>{
      if(this.props.item.modType==='LAYOUT'){
        return false;
      }else{
        if(this.props.item.is_avatar===true){
          // this.props.onChangeInputAction({
          //   section_index:this.props.section.section_index,
          //   itemIndex:this.props.item.itemIndex,
          //   item:this.props.item,
          //   ...this.props.subformObj
          // },[],'Files');
        }else{
          const totalFilesize = ((this.state.totalSize / (1024*1024)).toFixed(2));
          console.log(totalFilesize);
          //if(Number(totalFilesize)>Number(this.props.item.max)){
          if(Number(totalFilesize)>this.state.maxSize){
            this.props.failMessage('Image maximum size exceeded.');
            return false;
          }else if(isSet(this.props.item.files,[]).length>this.props.item.max){
            this.props.failMessage('Maximum '+this.props.item.max+' files only allowed.');
            return false;
          }  
            var inputField = this.refs.uploadMultipleFiles;
            inputField.click();
        }
      }
     
          
      
    }  
    changeHandlerFile =(event)=>{
    //  console.log(event.target.files[0]);
    }
    removeAddedFile = (Fileindex)=>{
      let updateFiles = isSet(this.props.item.files,[]);
      updateFiles = updateFiles.filter((item,index)=>{
        if(index!== Fileindex){
          return item;
        }
      })
      // this.setState({files:updateFiles});
      this.props.onChangeInputAction(this.props.fieldObj,updateFiles,'Files');
      
      setTimeout(() => {
        this.updateFilesSizes();
      }, 200);
    }
}

ImageUpload.defaultProps = {
  generator: false,
  className: "form-control"
}


const mapDispatchToProps = dispatch => {
  return {
    Loader : (boll) => dispatch(loader(boll)),
    succMessage : (msg) => dispatch(succMessage(msg)),
    failMessage : (msg) => dispatch(failMessage(msg)),
  };
}
export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(ImageUpload));
